import React from 'react'

const Index = (props) => {
  return <div className='app-container'>{props.children}</div>
}

export default Index
